import { create } from 'zustand'

interface ContactState {
  qrContactInfo: string | null
  
  // Actions
  fetchQrContactInfo: () => Promise<void>
}

export const useContactStore = create<ContactState>((set) => ({
  qrContactInfo: null,

  fetchQrContactInfo: async () => {
    try {
      const { getQrContactInfo } = await import('@/service/api/setting')
      const info = await getQrContactInfo()
      set({ qrContactInfo: info })
    } catch (error) {
      console.error('Failed to fetch contact info:', error)
    }
  }
}))
